import { render, staticRenderFns } from "./OrderItemTile.vue?vue&type=template&id=d6c9774c&"
import script from "./OrderItemTile.vue?vue&type=script&lang=ts&"
export * from "./OrderItemTile.vue?vue&type=script&lang=ts&"
import style0 from "./OrderItemTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports